import {CommonModule} from "@angular/common";
import {Component, Injector} from "@angular/core";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule, MatBottomSheetRef,} from "@angular/material/bottom-sheet";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";
import {ButtonModule} from "@app/presentation/components/button/button.module";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  standalone: true,
  templateUrl: "./error-modal.component.html",
  styleUrls: ["./error-modal.component.scss"],
  imports: [
    CommonModule,
    MatBottomSheetModule,
    AppBarModule,
    ButtonModule,
    TranslateModule,
  ],
})
export class ErrorModalComponent {

  readonly errorMessage: string = '';

  private readonly _close: () => void = () => {/* void */};

  constructor(
      private injector: Injector,
  ) {
    try {
      const bottomSheetRef = injector.get(MatBottomSheetRef);
      this._close = () => { bottomSheetRef.dismiss() };
      this.errorMessage = injector.get<{message: string}>(MAT_BOTTOM_SHEET_DATA).message;
    } catch {}

    try {
      const dialogRef = injector.get(MatDialogRef);
      this._close = () => { dialogRef.close() };
      this.errorMessage = injector.get<{message: string}>(MAT_DIALOG_DATA).message;
    } catch {}
  }

  close() {
    this._close();
  }
}
